// Existing feature flags
const isMonitoringEnabled = () =>
  ['production'].includes(process.env.GATSBY_ENV) && !process.env.GATSBY_IS_MONITORING_DISABLED;

const isLivePreviewEnabled = ['dev', 'staging'].includes(process.env.GATSBY_ENV); //todo: live preview needs fixing

const isMultiLanguageEnabled = () =>
  process.env.GATSBY_LOCALE === 'true' || ['dev', 'staging', 'production'].includes(process.env.GATSBY_ENV);

const getEnabledLocales = () => (isMultiLanguageEnabled() ? ['en-us', 'en-au'] : ['en-us']);
const isPersonalizeEnabled = process.env.PERSONALIZE_ENABLED === 'true' || false;
const isNewChatEnabled = process.env.CHAT_VERSION === 'messaging' || false;
const isGTMEnabled = ['production', 'staging'].includes(process.env.GATSBY_ENV);

const isLanguageSwitcherEnabled = false;

const isNoIndexEnv = process.env.GATSBY_ENV === 'staging';

const isNewDesktopInstallerModalEnabled = ['staging', 'production'].includes(process.env.GATSBY_ENV);

const isStockPagesEnabled = () => ['staging', 'dev', 'production'].includes(process.env.GATSBY_ENV);

module.exports = {
  isMonitoringEnabled,
  isLivePreviewEnabled,
  isMultiLanguageEnabled,
  getEnabledLocales,
  isPersonalizeEnabled,
  isNewChatEnabled,
  isGTMEnabled,
  isLanguageSwitcherEnabled,
  isNewDesktopInstallerModalEnabled,
  isStockPagesEnabled,
  isNoIndexEnv,
};
